<template>
  <div>
    <a-popconfirm
      v-if="isCustom"
      class="float-right"
      ok-text="Yes"
      cancel-text="No"
      @confirm="deleteIndex()"
    >
      <template slot="title">
        Are you sure you want to delete this index with all its values?
      </template>
      <a-button
        type="danger"
        :loading="deletingIndex"
        :disabled="deletingIndex"
      >
        Delete Index
      </a-button>
    </a-popconfirm>
    <a-tabs>
      <a-tab-pane key="values" tab="Values">
        <index-values :index="index" />
      </a-tab-pane>
      <a-tab-pane key="constituents" tab="Constituents">
        <constituents-list :index="index" />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import ConstituentsList from '../components/constituents/ConstituentsList.vue'
import IndexValues from '../components/index/IndexValues.vue'
import EventBus from '../event-bus/EventBus'

export default {
  components: { ConstituentsList, IndexValues },
  props: {
    index: {
      type: String,
      required: true,
    },
    isCustom: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      deletingIndex: false,
    }
  },
  methods: {
    async deleteIndex() {
      this.deletingIndex = true
      await this.$apollo.mutate({
        mutation: gql`
          mutation DeleteIndex($indexId: String!) {
            deleteIndex(indexId: $indexId) {
              id
            }
          }
        `,
        variables: {
          indexId: this.index,
        },
      })
      EventBus.$emit('indexDeleted', { id: this.index })
      this.$router.push('/indexDeleted')
    },
  },
}
</script>

<style></style>
